export const COORDINATES_DEGREES = "degrees";
export const COORDINATES_MINUTES = "minutes";
export const COORDINATES_SECONDS = "seconds";

export const COORDINATES_DEGREES_SYMBOL = "º";
export const COORDINATES_MINUTES_SYMBOL = `'`;
export const COORDINATES_SECONDS_SYMBOL = '"';
